"use client";

import { CountryInfo } from "@/store/types/countryTypes";
import React from "react";

const CountryJobsAfterGraduation: React.FC<{ country: CountryInfo }> = ({ country }) => {
  const sectionData = country?.jobsAfterGraduation;

  const jobCards = sectionData?.jobCards || [];

  const partTimeTitle = sectionData?.partTimeCallout?.title;
  const partTimeDesc = sectionData?.partTimeCallout?.description;

  if (jobCards.length === 0 && !partTimeDesc) {
    return null;
  }

  const heading =
    sectionData?.heading || `Jobs in ${country.countryName} After Graduation`;
  const subheading =
    sectionData?.subheading ||
    `In-demand sectors and indicative salaries for graduates working in ${country.countryName}.`;

  return (
    <div className="w-full my-12 space-y-6">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-[#1C2233] ff_poppins">
          {heading}
        </h2>
        {subheading && (
          <p className="mt-1.5 text-xs sm:text-sm text-[#667085] ff_poppins">
            {subheading}
          </p>
        )}
      </div>

      {/* JOB SECTOR CARDS */}
      {jobCards.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {jobCards.map((job, idx) => (
            <div
              key={idx}
              className="bg-white rounded-[18px] border border-[#E0D8FF] p-5 sm:p-6 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow gap-4"
            >
              <div>
                <h3 className="text-base font-bold text-[#1C2233] ff_poppins">
                  {job.title}
                </h3>
                <p className="mt-1 text-xs text-[#808A9D] ff_poppins font-medium">
                  {job.category}
                </p>
              </div>
              <span className="text-sm sm:text-base font-bold text-[#00A35C] ff_poppins whitespace-nowrap">
                {job.salaryRange}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* PART-TIME WORK CALLOUT */}
      {(partTimeTitle || partTimeDesc) && (
        <div className="bg-gradient-to-r from-[#FFF5F2] to-[#FFF9F5] border border-[#FFDCD2] rounded-[18px] p-6 sm:p-7 shadow-xs">
          {partTimeTitle && (
            <h4 className="text-sm sm:text-base font-bold text-[#1C2233] ff_poppins mb-1.5">
              {partTimeTitle}
            </h4>
          )}
          {partTimeDesc && (
            <p className="text-xs sm:text-sm text-[#525B73] ff_poppins leading-relaxed">
              {partTimeDesc}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default CountryJobsAfterGraduation;

